<template>
    <div class="d-flex flex-column overflow-auto" >
        <div class="m-3 flex-grow-1 overflow-auto">
            <label v-if="isAlreadyDispatched" style="color: red !important; font-style: italic;">
                {{ $t('res_Msgs_CorrespondenceAlreadyDispatched') }}
            </label>
            <div v-if="!isSimpleDispatch">
                <v-label>{{ $t("res_Label_Recipent")}} *</v-label>
                <multi-select class="light-bg add-arrow" v-model="recipient" label="name" placeholder="Select" track-by="recipientId" open-direction="bottom"
                    :options="recipients" :searchable="false" :internal-search="false" :clear-on-select="false"
                    :close-on-select="true" :options-limit="300" :max-height="600" :show-no-results="false"
                    :hide-selected="false" :multiple="false"  ref="multiselect1">
                </multi-select>
            </div>
            <div v-else>
                <v-label>{{ $t("res_Label_Recipent")}}</v-label>
                <div v-for="(item, i) in recipients" :key="i">
                    <v-label style="font-weight: bold !important; padding-left: 20px !important;">{{ item.name }}</v-label>
                </div>
            </div>
            <div style="padding-top: 15px">
                <v-label>{{ $t("res_Label_IncludeAttchments")}}</v-label>
                <v-checkbox style="margin: 0px;" v-model="withAttachments" label=""></v-checkbox>
            </div>
            <div style="padding-top: 15px">
                <v-label>{{ $t("res_Label_Notes") }}</v-label>
                <v-textarea v-model="notes" label="" class="light-bg" :placeholder="$t('res_Label_defaultTextValue')"></v-textarea>
            </div>
        </div>
        
        <v-card-actions class="top-shadow gap-3 text-start">
            <v-spacer></v-spacer>
            <v-btn class="light-blue flex-1" @click="closeDialog">{{ $t("res_ButtonText_Cancel")}}</v-btn>
            <v-btn class="primary flex-1" @click="sendDispatch" :disabled="isDispatchDisabled">{{ $t("res_ButtonText_Dispatch")}}</v-btn>
        </v-card-actions>
    </div>
</template>

<script>
    import constants from "@/assets/js/constants.js"
    import axios from "axios"
    import MultiSelect from 'vue-multiselect'
    import * as utils from '@/assets/js/common.js'

    export default {
        name: 'DispatchLetter',
        components: { MultiSelect },
        data: function () {
            return {
                loading: false,
                attachments: [],
                recipients: [],
                recipient: {},
                withAttachments: false,
                notes: '',
                isSimpleDispatch: false,
                isDispatchDisabled: false,
                isAlreadyDispatched: false,
                utils: utils
            };
        },
        props: {
            documentId: { type: [String, Number], default: '0' },
            dialogModelShow: { type: Boolean, default: false }
        },
        mounted ()
        {
            this.getDocumentRecepient()
            this.checkIsDispatched()
        },
        methods: 
        {
            closeDialog() 
            {
                this.$emit('closeDialog')
            },
            getRecipients()
            {
                this.loading = true

                this.recipients = []
                axios.get(constants.baseApiUrl + 'Dispatch/GetDispatchEntities?documentId=' + this.documentId, { headers: constants.headers})
                    .then(res => 
                    {
                        this.recipients = res.data
                        this.isDispatchDisabled = (this.recipients.length == 0)
                        this.loading = false 
                    })
                    .catch(() => this.loading = false)
                    .finally(() => this.loading = false)
            },
            sendDispatch: async function () 
            {
                if (this.isSimpleDispatch && this.recipients.length == 0)
                {
                    window.showAlert('res_Msgs_NoRecipientsSelected', 'warning')
                    return false
                }
                else
                {
                    if (!this.isSimpleDispatch && (utils.isNullOrEmpty(this.recipient) || utils.isNullOrEmpty(this.recipient.recipientId)))
                    {
                        window.showAlert('res_Msgs_NoRecipientsSelected', 'warning')
                        return false
                    }
                }

                var recipientIds = ''
                if (this.isSimpleDispatch)
                    recipientIds = this.recipients.map(x => x.id).join(',')
                else
                    recipientIds = this.recipient.recipientId
                
                var methodUrl = 'Dispatch/DispatchCorrespondence?documentId=' + this.documentId + '&recipientIds=' + recipientIds
                    + '&notes=' + this.notes + '&includeAttachments=' + this.withAttachments

                window.showLoading();
                axios.get(constants.baseApiUrl + methodUrl, { headers: constants.headers })
                    .then(res => 
                    {
                        if(res.data != null && res.data == true)
                        {
                            window.showAlert('res_Msgs_CorrespondenceDispatched', 'success')
                            this.closeDialog();
                        }
                        else if(res.data != null && res.data.result === false && res.data.status == 409) {
                            window.showAlert('res_Msgs_CorrespondenceAlreadyDispatched', 'warning')
                        }
                        else {
                            window.showAlert(res.data.message, 'warning')
                        }
                    })
                    .catch(err => console.warn(err))
                    .finally(() => window.hideLoading());
            },
            getDocumentRecepient()
            {
                if (this.isSimpleDispatch)
                {
                    axios.get(constants.baseApiUrl + 'Dispatch/GetDispatchEntitiesFromDocument?documentId=' + this.documentId)
                        .then(res => 
                        {
                            this.recipients = res.data
                            this.isDispatchDisabled = (this.recipients.length == 0)
                            this.loading = false 
                        })
                        .catch(() => this.loading = false)
                        .finally(() => this.loading = false)
                }
                else
                    this.getRecipients()
            },
            checkIsDispatched()
            {
                axios.get(constants.baseApiUrl + 'Dispatch/IsDispatched?documentId=' + this.documentId)
                    .then(res => 
                    {
                        this.isAlreadyDispatched = res.data
                    })
                    .catch(() => this.loading = false)
                    .finally(() => this.loading = false)
            }
        },
        watch:
        {
            documentId: function()
            {
                this.getDocumentRecepient();
            },
            dialogModelShow(newVal, oldVal) 
            {
                if (newVal != oldVal) 
                {
                    if (newVal == true) 
                    {
                        this.getDocumentRecepient()
                        this.checkIsDispatched()
                    }
            }
            },
        }
    }
</script>

<style>
    .v-icon.v-icon.v-icon--link {
        cursor: pointer;
        outline: none;
        left: 0% !important;
        position: relative !important;
    }
</style>